export type VideoMediaJson = {
  id?: string;
  date?: string;
  title?: string;
  duration?: string;
  provider?: string;
  description?: string;
  thumbnailImageUrl?: string;
  channelTitle?: string;
  tags?: string[];
  lastSyncedAt?: string;
};

export type VideoFallbackData = {
  title?: string | null;
  description?: string | null;
  image?: unknown;
  video?: VideoMediaJson | null;
};

export const getVideoTitle = (
  data: VideoFallbackData | null | undefined
): string | undefined => data?.title || data?.video?.title || undefined;

export const getVideoDescription = (
  data: VideoFallbackData | null | undefined
): string | undefined =>
  data?.description || data?.video?.description || undefined;

export const getVideoThumbnailUrl = (
  data: VideoFallbackData | null | undefined
): string | undefined => data?.video?.thumbnailImageUrl || undefined;

export const hasVideoImageAsset = (
  data: VideoFallbackData | null | undefined
): boolean => Boolean(data?.image);
